import Filter from "sap/ui/model/Filter";
import FilterOperator from "sap/ui/model/FilterOperator";
import V4Context from "sap/ui/model/odata/v4/Context";
import { MeasurementUnit } from "vamos/cockpit/model/odata/VamosModel";
import BaseService from "vamos/cockpit/base/services/BaseService";
import VamosComponent from "vamos/cockpit/Component";

export default class MeasurementUnitService extends BaseService{

    constructor(component:VamosComponent){
        super(component,"/MeasurementUnits");
    }
    public async findPieceEntry():Promise<MeasurementUnit>{
        const listBinding = this.getListBinding();
        const filter:Filter = new Filter("SapCode", FilterOperator.EQ, "01");
        listBinding.filter(filter);
        const contexts:V4Context[] = await listBinding.requestContexts();
        if(contexts.length === 1) {
            return contexts[0].getObject() as MeasurementUnit;
        }
        return null;
    }

    public async findPieceAndLengthUnits():Promise<V4Context[]>{
        const listBinding = this.getListBinding();
        const filter:Filter = new Filter({
            filters: [
                new Filter("SapCode", FilterOperator.EQ, "01"),
                new Filter("SapCode", FilterOperator.EQ, "02"),
            ],
            and: false,
        });
        listBinding.filter(filter);
        return await listBinding.requestContexts();
    }

}